const state = {
    selectItem: {}
  };
  
  // getters
  const getters = {
    getSelectItem: state => state.selectItem
  };
  
  // mutations
  const mutations = {
    setSelectItem(state, item) {
      state.selectItem = item
    }
  };
  
  // actions
  const actions = {};
  
  export default {
    state,
    getters,
    actions,
    mutations,
  };